export class EnrollDiplomInfo {
  speciality: number = null;
  otherSpeciality: string;
  qualification_commission_decision_date: Date;
  qualification_commission_decision_date_college: Date;
  diplom_series: string = '';
  diplom_number: string = '';
  diplom_give_date: Date;
  diplom_with_honors: number = null;
  diplom_scan: any;
  diplom_app_scan: any;
  essay: any;

}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/edu-info/enroll-diplom-info.ts